// extracted by mini-css-extract-plugin
export default {"root":"ehr-page__pages__profile-page__contact-person-list__root","CardWrapper":"ehr-page__pages__profile-page__contact-person-list__CardWrapper"};